import { useNavigate, useParams } from "react-router-dom";
import Divider from "../../components/Common/Divider";
import Heading from "../../components/Common/Heading";
import Section from "../../components/Common/Section";
import IzobrazevanjeForm from "./IzobrazevanjeForm";
import ApiStatus from "../../components/ApiStatus";
import { useFetchIzobrazevanjeWithSifranti, useUpdateIzobrazevanjeDraft, useUpdateIzobrazevanjePublish, useDeleteIzobrazevanje } from "./IzobrazevanjeHooks";
import getApiExceptionObjectFromAxiosError from "../../utils/ProcessException";
import { IzobrazevanjeStatus, IzobrazevanjeVrsta } from "../../utils/Enums";
import IzobrazevanjeJavnoForm from "./IzobrazevanjeJavnoForm";

const IzobrazevanjeEdit = () => {
    const { izobrazevanjeId } = useParams();
    if (!izobrazevanjeId)
        throw Error("Manjka parameter izobrazevanjeId");

    const izobrazevanjeIdInt = parseInt(izobrazevanjeId);

    const { data, status, isSuccess } = useFetchIzobrazevanjeWithSifranti(izobrazevanjeIdInt);
    const updateIzobrazevanjeMutatiedDraft = useUpdateIzobrazevanjeDraft();
    const updateIzobrazevanjeMutatiedPublish = useUpdateIzobrazevanjePublish();
    const deleteIzobrazevanje = useDeleteIzobrazevanje();
    const nav = useNavigate();

    let error = null;
    if (updateIzobrazevanjeMutatiedDraft.error)
        error = updateIzobrazevanjeMutatiedDraft.error;
    if (updateIzobrazevanjeMutatiedPublish.error)
        error = updateIzobrazevanjeMutatiedPublish.error;

    if (!isSuccess)
        return (
            <Section>
                <Heading>Urejanje izobraževanja
                    <Divider />
                </Heading>
                <ApiStatus status={status}></ApiStatus>
            </Section>
        )   

    if (data.izobrazevanje.status === IzobrazevanjeStatus.Objavljeno)
        nav(`/izobrazevanje/${data.izobrazevanje.izobrazevanjeId}`);

    return (
        <Section>
            <Heading>
                Urejanje izobraževanja
                <Divider />
                <p>
                    <span className="red">*</span>
                    polja, označena z zvezdico, so obvezna
                </p>
            </Heading>
            { (data.izobrazevanje.vrsta === IzobrazevanjeVrsta.Javno) ? 
                <IzobrazevanjeJavnoForm
                    izobrazevanje={data.izobrazevanje}
                    izobrazevanjeTipi={data.izobrazevanjeTipi}
                    onSaveDraft={async (izobrazevanje, onSuccessCallback) =>
                        await updateIzobrazevanjeMutatiedDraft.mutateAsync({
                            izobrazevanje,
                            onSuccessCallback,
                        })
                    }
                    onSavePublish={async (izobrazevanje, onSuccessCallback) =>
                        await updateIzobrazevanjeMutatiedPublish.mutateAsync({
                            izobrazevanje,
                            onSuccessCallback,
                        })
                    }
                    onDelete={(i) => deleteIzobrazevanje.mutate(i)}
                    apiException={getApiExceptionObjectFromAxiosError(error)}
                /> :
                <IzobrazevanjeForm
                    izobrazevanje={data.izobrazevanje}
                    izobrazevanjeTipi={data.izobrazevanjeTipi}
                    podrocja={data.podrocja}
                    onSaveDraft={async (izobrazevanje, onSuccessCallback) =>
                        await updateIzobrazevanjeMutatiedDraft.mutateAsync({
                            izobrazevanje,
                            onSuccessCallback,
                        })
                    }
                    onSavePublish={async (izobrazevanje, onSuccessCallback) =>
                        await updateIzobrazevanjeMutatiedPublish.mutateAsync({
                            izobrazevanje,
                            onSuccessCallback,
                        })
                    }
                    onDelete={(i) => deleteIzobrazevanje.mutate(i)}
                    apiException={getApiExceptionObjectFromAxiosError(error)}
                /> }
        </Section>
    );
}

export default IzobrazevanjeEdit;
